import React from 'react'
import { useStyles } from './styles'

import { Message } from 'data/Chat'
import { themeObj } from 'styling/theme'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

import { urlRegex, replaceWithHyperlink } from 'utils/chat'

interface ChatMessageProps {
    msg: Message
}

const ChatMessage: React.FC<ChatMessageProps> = ({ msg }) => {
    const classes = useStyles()
    const { isAuthenticated, user } = useAuthenticatedState()
    const escapedMessage = msg.body
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

    const chatMsg = urlRegex.test(escapedMessage) ? replaceWithHyperlink(escapedMessage) : escapedMessage

    let color = themeObj.colors.light.grey
    if (isAuthenticated && msg.userId === user._id) {
        color = user.chatColor ? user.chatColor : themeObj.colors.green
    } else if (msg.chatColor) {
        color = msg.chatColor
    }

    return (
        <div className={`${classes.msg} d-flex`}>
            <div
                className={`${classes.msgFrom} flex-grow-1 body-3`}
                style={{
                    color,
                }}
            >
                <span>{msg.displayName}:</span>
                <p
                    className={`${classes.msgBody} body-3 text-light-grey`}
                    dangerouslySetInnerHTML={{ __html: chatMsg }}
                />
            </div>
        </div>
    )
}

export default React.memo(ChatMessage)
